export const rankCoordinates: string[] = ["A", "B", "C", "D", "E", "F", "G", "H"];
